
import DocumentContractProfileTab
  from "@/components/organisms/ContractProfileTemplatePanel/DocumentContractProfileTab.vue";
import GenericContractProfileTab
  from "@/components/organisms/ContractProfileTemplatePanel/GenericContractProfileTab.vue";
import FormPageTemplate from "@/components/templates/FormPageTemplate.vue";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import {defineComponent, PropType} from "vue";
import {ContractProfile} from "@/store/modules/hcs/contractProfile/model";
import {ContractProfileTemplate} from "@/store/modules/hcs/contractProfileTemplate/model";

export default defineComponent({
  name: "ContractProfileTemplateForm",
  components: {TextFieldLike, FormPageTemplate, DocumentContractProfileTab, GenericContractProfileTab},
  props: {
    contractProfileTemplateId: {
      type: [String, null] as PropType<null | string>,
      required: false,
      default: null,
    },
    tradeContractId: {
      type: [String, null] as PropType<null | string>,
      required: false,
      default: null,
    },
    tradeContractFormatId: {
      type: [String, null] as PropType<null | string>,
      required: false,
      default: null,
    },
    contractProfileTemplate: {
      type: [Object, null] as PropType<null | ContractProfileTemplate>,
      required: false,
      default: null,
    },
    contractProfiles: {
      type: Array as PropType<ContractProfile[]>,
      required: true,
    },
    showApplyButton: {
      type: Boolean,
      default: false
    },
    dirty: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    "dirty", "save", "change:contract-profiles",
  ],
  computed: {
    contractProfileTemplateView(): ContractProfileTemplate {
      return (this.contractProfileTemplate ?? {}) as ContractProfileTemplate;
    }
  },
  methods: {
  },
  watch: {
    contractProfileTemplateView: {
      handler() {
        this.$emit('dirty');
      },
      deep: true,
    }
  }
});
